module.exports = __webpack_public_path__ + "img/part4-1.21c289d4.png";